import dayjs from "dayjs";

export const COLUMN_HEADER_MAP: Record<string, string> = {
  total_client_submissions: "Total Candidates Submitted",
  client_submission: "Candidate Submissions",
  current_pending_review: "Current Pending Review",
  dropped_candidates: "Dropped Candidates",
  candidate_in_interviews: "In Interviews",
  current_candidates_in_final_rounds: "Current Final Stage Candidates",
  joined: "Closures Till Date",
};

export const COLUMN_ORDER = [
  "total_client_submissions",
  "client_submission",
  "current_pending_review",
  "dropped_candidates",
  "candidate_in_interviews",
  "current_candidates_in_final_rounds",
  "joined",
];

export const buildDateRangeFromJobCreated = (
  jobCreatedAt?: string,
  dateRange?: string[],
) => {
  if (!jobCreatedAt) {
    return { startDate: undefined, endDate: undefined };
  }

  const start = dateRange?.[0]
    ? dayjs(dateRange[0]).format("YYYY-MM-DD")
    : dayjs(jobCreatedAt).format("YYYY-MM-DD");

  const end = dateRange?.[1]
    ? dayjs(dateRange[1]).format("YYYY-MM-DD")
    : dayjs().format("YYYY-MM-DD");

  return { startDate: start, endDate: end };
};

export const getDefaultDateRangeFromJobCreated = (jobCreatedAt?: string) => {
  if (!jobCreatedAt) return [];

  const start = dayjs(jobCreatedAt).format("YYYY-MM-DD");
  const end = dayjs().format("YYYY-MM-DD");

  return [start, end];
};

export const getCurrentMonthDateRange = (): string[] => {
  return [
    dayjs().startOf("month").format("YYYY-MM-DD"),
    dayjs().format("YYYY-MM-DD"),
  ];
};

export const formatColumnHeader = (key: string): string => {
  return key
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

export const formatDate = (date: string): string => {
  return dayjs(date).format("MMM DD, YYYY");
};

export const formatRange = (range: string): string => {
  const [startDate, endDate] = range.split(" to ");
  return `${dayjs(startDate).format("MMM DD, YYYY")} - ${dayjs(endDate).format("MMM DD, YYYY")}`;
};

export const formatWeek = (week: string): string => {
  const match = week.match(/Week (\d+) \((.+) to (.+)\)/);
  if (!match) return week;

  const [, weekNum, startDate, endDate] = match;
  return `Week ${weekNum} (${dayjs(startDate).format("MMM DD")} - ${dayjs(endDate).format("MMM DD")})`;
};

export const formatCellValue = (value: any): string => {
  if (value === null || value === undefined) return "-";
  if (typeof value === "number") return value.toLocaleString();
  return String(value);
};

export const ANALYTICS_INTERVAL_OPTIONS = [
  { label: "Range", value: "range" },
  { label: "Weekly", value: "weekly" },
];

export const extractDynamicColumns = (
  rows: Record<string, any>[],
  excludeKeys: string[] = ["date", "week", "range"],
): string[] => {
  const set = new Set<string>();

  rows.forEach((row) => {
    Object.keys(row).forEach((key) => {
      if (!excludeKeys.includes(key)) {
        set.add(key);
      }
    });
  });

  return Array.from(set).sort();
};

export const getPeriodSortingValue = (
  row: any,
  intervalValue: string,
): number => {
  if (intervalValue === "range") {
    const rangeStr = row.range || "";
    const startDate = rangeStr.split(" to ")[0];
    return dayjs(startDate).valueOf();
  }

  const match = row.week?.match(/\((.+) to (.+)\)/);
  return match ? dayjs(match[1]).valueOf() : 0;
};
